import * as React from 'react';
import { Header } from 'semantic-ui-react';

const Info: React.FunctionComponent<{ titulo: string }> = props => {
    const { titulo, children } = props;
    return (
        <div>
            <Header as='h3'>{titulo}</Header>
            {children}
        </div>
    );
};

export default Info;



// WEBPACK FOOTER //
// ./src/modulos/Alumnos/paginas/FichaDeAlumno/paginas/InformacionGeneral/componentes/Info.tsx